import React from "react";
import PropTypes from "prop-types";
import { makeStyles, lighten } from "@material-ui/core/styles";
import EyeIcon from "@material-ui/icons/RemoveRedEye";
import TablePagination from "@material-ui/core/TablePagination";
import { Badge } from "react-bootstrap";
import clsx from "clsx";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  Toolbar,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
const headRows = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Ad, soyad, ata adı",
  },
  {
    id: "employeePin",
    numeric: false,
    disablePadding: false,
    label: "Fin kod ",
  },
  {
    id: "dateTime",
    numeric: false,
    disablePadding: false,
    label: "Tarix",
  },
  {
    id: "dateTime",
    numeric: false,
    disablePadding: false,
    label: "Saat",
  },
  {
    id: "device",
    numeric: false,
    disablePadding: false,
    label: "Qurğular",
  },
  {
    id: "devicePlace",
    numeric: false,
    disablePadding: false,
    label: "Qurğu məkanı",
  },

  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Vəziyyət",
  },

  {
    id: "tools",
    numeric: false,
    disablePadding: true,
    label: "Detallı Məlumatlar",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;

  return (
    <TableHead>
      <TableRow>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            sortDirection={orderBy === row.id ? false : false}
            className="employeeReport"
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" ? onRequestSort(row.id) : null;
              }}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  rowCount: PropTypes.number.isRequired,
  numSelected: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: "flex-end",
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },

  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  dense: {
    margin: theme.spacing(2),
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected, onDeviceLogFilterExport } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.actions}>
        <Tooltip title="Excel yüklə" placement="top">
          <button
            className="btn btn-sm btn-icon btn-bg-light btn-text-success btn-hover-success mr-2 h5 rounded-circle flex-shrink-0"
            onClick={onDeviceLogFilterExport}
          >
            {/* <ExportIcon /> */}
            test
          </button>
        </Tooltip>
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
}));

export default function EnhancedTable({
  saps,
  isLoading,
  setChooseSapId,
  setOpenView,
  deleteSapsIds,
  setDeleteSapsIds,
  setSortField,
  setOrderByTable,
  sortField,
  orderBy,
  updateSkip,
  updateTake,
  count,
  isError,
  // setShowLog,
  onBiometricLogFilterExport,
}) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // const permissionList = useSelector(state => state.auth.permissionList)

  function handleRequestSort(property) {
    const isDesc = sortField === property && orderBy === "desc";
    setOrderByTable(isDesc ? "asc" : "desc");
    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = saps.map((n) => n.id);
      setDeleteSapsIds(newSelecteds);
      return;
    }
    setDeleteSapsIds([]);
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const isSelected = (id) => deleteSapsIds.indexOf(id) !== -1;

  return (
    <div className={`${classes.root} NoShadow `}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}

        <div className={classes.tableWrapper}>
          {saps && saps.length ? (
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                numSelected={deleteSapsIds.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={saps.length}
                order={orderBy}
                orderBy={sortField}
                onRequestSort={handleRequestSort}
                onBiometricLogFilterExport={onBiometricLogFilterExport}
              />

              <TableBody>
                {saps.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                    >
                      <TableCell component="th" id={labelId} scope="row">
                        {row.name} {row.surname} {row.middleName}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.pin}
                      </TableCell>

                      <TableCell component="th" id={labelId} scope="row">
                        {row.dateTime?.split("t")[0]}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.dateTime?.split("t")[1]}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.device}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.devicePlace}
                      </TableCell>

                      <TableCell padding="default" className="pr-4 px-4">
                        <Badge
                          variant={
                            row.status === "INACTIVE"
                              ? "info"
                              : row.status === "ACTIVE"
                              ? "success"
                              : "-"
                          }
                        >
                          {row.status === "INACTIVE"
                            ? "Deaktiv"
                            : row.status === "ACTIVE" && "Aktiv"}
                        </Badge>
                      </TableCell>

                      <TableCell component="th" id={labelId} scope="row">
                        <Tooltip title="Göstər" placement="top">
                          <button
                            aria-label="view"
                            className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                            onClick={() => {
                              setChooseSapId(row.id);
                              setOpenView();
                            }}
                          >
                            <EyeIcon />
                          </button>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : !saps.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}
        </div>
        {count > 5 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={count}
            labelRowsPerPage={"Sətirlərin sayı"}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Əvvəlki səhifə",
            }}
            nextIconButtonProps={{
              "aria-label": "Növbəti səhifə",
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        )}
      </Paper>
    </div>
  );
}
